/* Shows the configured price on the Add to Order button: the selected variant, plus Winespot Care Plus
   and the personalization fee when they are chosen, times the quantity. */
(function () {
  const init = () => {
    const price = document.querySelector('[data-cta-price]');
    const variantsData = document.querySelector('[data-cta-variants]');
    const button = price && price.closest('button');
    const form = button && button.form;
    if (!price || !variantsData || !button || !form) return;

    const variants = new Map(JSON.parse(variantsData.textContent).map((variant) => [String(variant.id), variant.price]));
    const format = new Intl.NumberFormat(price.dataset.locale || undefined, {
      style: 'currency',
      currency: price.dataset.currency || 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });

    const update = () => {
      const base = variants.get(String(form.elements['id'] && form.elements['id'].value));
      if (base === undefined || button.disabled) {
        price.hidden = true;
        return;
      }

      let each = base;

      const carePlus = document.querySelector('.ws-care-card.is-selected[data-care-type="care-plus"]');
      if (carePlus) each += Number(carePlus.dataset.price) || 0;

      const personalization = window.WSPersonalization;
      if (personalization && personalization.design && personalization.config) {
        each += Number(personalization.config.feePrice) || 0;
      }

      const quantity = Math.max(1, parseInt(form.elements['quantity'] && form.elements['quantity'].value, 10) || 1);
      price.textContent = format.format((each * quantity) / 100);
      price.hidden = false;
    };

    // variant (hidden id input) and quantity changes bubble up as change events
    document.addEventListener('change', (event) => {
      if (event.target.matches && event.target.matches('[name="id"], [name="quantity"]')) update();
    });
    document.addEventListener('ws:configchange', update);
    // sold out / unavailable toggles the disabled attribute: hide the price then
    new MutationObserver(update).observe(button, { attributes: true, attributeFilter: ['disabled'] });

    update();
    window.addEventListener('load', update);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
